import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EliotUser } from 'src/app/models/user/user.model';
import { environment } from 'src/environments/environment';
import { AuthService } from './authentication/auth.service';
import { TranslateFirebaseService } from './utils/translate-firebase.service';

@Injectable()
export class BaseApiService {

  constructor(protected httpClient: HttpClient,
    protected translate?: TranslateFirebaseService) {
    }

  protected getUpsApiHost(): string {
    return environment.UpsApiEndpoint;
  }

  protected getEliotApiHost(): string {
    return environment.EliotApiEndpoint;
  }


}
